<template>
    <div>
        <div class="top">
            <base-divider text="会员缴费"/>
        </div>
        <div class="pay">
            <div class="b-left">
                <el-form>
                    <el-form-item label="缴费年限">
                        <el-input-number
                                v-model="formData.years"
                                :min="1"
                                :max="10"
                                @change="preOrder"
                                label="描述文字"
                                size="mini">
                        </el-input-number>
                    </el-form-item>
                    <el-form-item label="支付金额">
                        {{formData.price}}元
                    </el-form-item>
                    <el-form-item label="支付方式">
                        微信支付
                    </el-form-item>
                </el-form>
            </div>
            <div class="b-right" id="qrcode">
                <div>
                    <i class="el-icon-success" v-if="paySuccess"></i>
                    <vue-qr :text="qrInfo.qrCode" v-if="qrInfo.qrCode"></vue-qr>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueQr from 'vue-qr'
    import {mapState, mapActions} from 'vuex'
    import {getWxPayQrcode, closeOrder, getOrderPage, getUserInfo} from '@/http/request'
    import BaseDivider from "../../../components/BaseDivider/BaseDivider"

    export default {
        name: "pay",
        components: {BaseDivider, VueQr},
        data() {
            return {
                paySuccess: false, // 支付成功
                data: {},
                qrInfo: {
                    qrCode: null
                },
                formData: {
                    payType: 'NATIVE',
                    price: '',
                    years: 1
                },
                formOrderRecord: {
                    limit: 10,
                    page: 1,
                    orderField: 'payStatus'
                }
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo,
                commodityInfo: state => state.commodityInfo
            })
        },
        created() {
            this.$set(this.formData, 'price', this.commodityInfo.price);
            this.initData();
        },
        methods: {
            ...mapActions(['setUserInfo']),

            // 页面初始化数据
            initData() {

                // 获取缴费记录
                this.getOrderPage();
            },

            // 欲下单
            async preOrder() {
                const loadingInstance = this.$loading({
                    target: document.querySelector('qrcode'),
                    text: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                this.qrInfo.orderNo && await closeOrder(this.qrInfo.orderNo).then(({data}) => {
                    if (data.code === 0) {
                        console.log('取消成功');
                        this.closeSocket();
                    }
                })

                this.$set(this.formData, "price", this.commodityInfo.price * this.formData.years);
                await getWxPayQrcode({...this.formData, levelId: this.commodityInfo.id}).then(({data}) => {
                    loadingInstance.close();
                    if (data.code === 0) {
                        this.qrInfo = data.data;
                        this.connectSocket();
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.msg
                        })
                    }
                })
            },

            // 获取缴费记录
            getOrderPage() {
                // 查询缴费记录列表中是否存在未支付的订单，如果存在取出未支付的订单支付，如果不存在，调用欲下单接口
                getOrderPage(this.formOrderRecord).then(({data}) => {
                    if (data.code === 0) {
                        const [obj] = data.data.list
                        if (obj.payStatus === 0) {
                            this.qrInfo = obj
                        } else {
                            this.preOrder();
                        }
                    }
                })
            },

            // 获取个人信息
            getUserInfo() {
                getUserInfo().then(({data}) => {
                    if (data.code === 0) {
                        this.setUserInfo(data.data);
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.msg
                        })
                    }
                })

            },

            // 连接socket
            connectSocket() {
                const that = this;
                const url = `${process.env.VUE_APP_BASE_SOCKET_URL}?type=0&orderNo=${this.qrInfo.orderNo}`;
                this.socket = new WebSocket(url);
                this.socket.onopen = () => {
                    console.log('socket连接成功')
                }
                this.socket.onmessage = (e) => {
                    const data = JSON.parse(e.data);
                    if (data.msg === 'success') {
                        this.paySuccess = true;
                        this.$message({
                            type: 'success',
                            message: '支付成功',
                            onClose: async () => {
                                await this.getUserInfo();
                                await that.$router.replace('/userCenter/userInfo');
                            }
                        })
                    }
                }
                this.socket.onclose = () => {
                    console.log('socket 关闭成功')
                }
            },

            // 断开socket
            closeSocket() {
                this.socket.close();
            }
        },
    }
</script>

<style lang="less" scoped>
    .pay {
        display: flex;
        margin-top: 50px;
        .b-left, .b-right {
            flex: 1;
            &.b-right {
                text-align: right;
                padding-right: 30px;
                div {
                    width: 120px;
                    height: 120px;
                    margin: 0 auto;
                    position: relative;
                    i {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        font-size: 100px;
                        background: rgba(255, 255, 255, .7);
                        color: #67C23A;
                    }
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
</style>